import { j as e } from "./jsx-runtime-e6RZPHeG.js";
import { memo as i } from "react";
const m = ({
  title: l,
  titleId: o,
  ...c
}) => /* @__PURE__ */ e.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 1024 1024",
    role: "img",
    "aria-labelledby": o,
    ...c,
    children: [
      l ? /* @__PURE__ */ e.jsx("title", { id: o, children: l }) : null,
      /* @__PURE__ */ e.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M512 42.668C253.215 42.668 42.668 253.184 42.668 512S253.217 981.332 512 981.332c258.785 0 469.332-210.516 469.332-469.332S770.783 42.668 512 42.668m308.978 221.61c53.451 66.254 86.043 150.459 87.673 241.845-17.928-3.589-93.214-17.623-183.498-17.623-29.008 0-59.643 1.632-90.281 5.221-2.609-6.201-5.214-12.73-7.821-18.931-7.822-18.603-16.621-37.206-25.422-55.484 138.519-57.769 205.332-137.081 219.349-155.032zM512 116.103c100.059 0 191.319 37.206 261.392 98.567-11.081 15.014-71.051 90.082-204.681 140.669-61.928-113.253-129.719-207.252-145.689-229.119a397.524 397.524 0 0 1 88.979-10.117zm-170.46 38.51c13.689 18.931 81.481 113.581 145.038 226.182-170.46 44.715-321.689 47.651-358.519 47.651h-3.911c26.728-121.087 108.208-221.61 217.392-273.833M115.349 512.652c0-3.265 0-6.529.328-9.79h10.43c49.214 0 220-4.244 396-56.465 10.758 20.887 20.86 42.102 30.311 63.318-4.562 1.304-8.8 2.612-13.038 3.916-198.489 64.298-307.349 234.014-323.97 261.756-62.251-70.171-100.06-161.885-100.06-262.736zM512 909.205c-90.932 0-174.698-30.681-241.838-82.573 11.408-22.195 93.54-170.37 310.608-246.09h.328c54.43 141.974 77.57 261.104 83.762 297.986-46.932 19.583-98.43 30.681-152.86 30.681zm224.562-69.847c-5.214-30.681-26.727-142.302-75.94-278.403 27.702-4.244 54.43-5.874 79.851-5.874 82.786 0 147.643 18.279 162.638 22.847-17.928 108.033-79.851 201.375-166.549 261.428z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), s = i(m);
export {
  s as default
};
